import * as React from 'react';
import { CnInput, formilyReact, CnIcon, Box, Grid } from '@alife/cn-ui';
import ParamsSelectSetter from "./params-select-setter";
import "./params-array-form.scss";
var observer = formilyReact.observer,
  useField = formilyReact.useField,
  ArrayField = formilyReact.ArrayField,
  Field = formilyReact.Field;
export var PARAMS_CONFIG_LAYOUT = [{
  title: '参数Key',
  span: 8
}, {
  title: '参数Value',
  span: 14
}, {
  title: '操作',
  span: 2
}];
var Span = PARAMS_CONFIG_LAYOUT.map(function (_ref) {
  var span = _ref.span;
  return span;
});
var rowGutter = 6;
var ArrayComponent = observer(function (_ref2) {
  var _field$value;
  var isFormHook = _ref2.isFormHook;
  var field = useField();
  return /*#__PURE__*/React.createElement("div", null, (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      key: index,
      style: {
        width: '100%',
        padding: '3px 0'
      },
      align: 'top',
      gutter: rowGutter
    }, /*#__PURE__*/React.createElement(Grid.Col, {
      span: Span[0]
    }, /*#__PURE__*/React.createElement(Field, {
      name: index + ".key",
      component: [CnInput, {
        style: {
          width: '100%'
        },
        placeholder: '请输入参数名'
      }]
    })), /*#__PURE__*/React.createElement(Grid.Col, {
      span: Span[1]
    }, /*#__PURE__*/React.createElement(Field, {
      name: index + ".value",
      component: [ParamsSelectSetter]
    })), /*#__PURE__*/React.createElement(Grid.Col, {
      span: Span[2]
    }, /*#__PURE__*/React.createElement(Box, {
      direction: 'row',
      align: 'center',
      justify: 'center',
      spacing: 6,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(CnIcon, {
      style: {
        cursor: 'pointer',
        color: '#284cc0',
        height: '32px'
      },
      type: "add-r",
      size: 'large',
      onClick: function onClick() {
        field.insert(index + 1, {});
      }
    }), field.value.length > 1 && /*#__PURE__*/React.createElement(CnIcon, {
      type: "minus-r",
      size: 'large',
      style: {
        cursor: 'pointer',
        color: '#e55346',
        height: '32px'
      },
      onClick: function onClick() {
        field.remove(index);
      }
    }))));
  }));
});
export default (function (_ref3) {
  var name = _ref3.name,
    isFormHook = _ref3.isFormHook;
  if (!Box || !Grid || !(Grid !== null && Grid !== void 0 && Grid.Row) || !(Grid !== null && Grid !== void 0 && Grid.Row)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'params-container'
  }, /*#__PURE__*/React.createElement(Box, {
    direction: 'row',
    className: 'params-header',
    align: 'center'
  }, /*#__PURE__*/React.createElement(Grid.Row, {
    style: {
      width: '100%'
    },
    gutter: rowGutter
  }, PARAMS_CONFIG_LAYOUT.map(function (config) {
    var span = config.span,
      configTitle = config.title;
    return /*#__PURE__*/React.createElement(Grid.Col, {
      span: span,
      key: configTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: 'configTitleItem'
    }, configTitle));
  }))), /*#__PURE__*/React.createElement(ArrayField, {
    name: name,
    component: [ArrayComponent, {
      isFormHook: isFormHook
    }]
  }));
});